import { FC, Fragment, useState } from "react";
import { Box, Stack } from "@mui/material";
import { ColDef, GridApi } from "ag-grid-community";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsHistoryProcessedDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { budgetDetailsHistoryTableColumnDefs } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/budgetDetailsHistoryTableColumnDefs";
import { AGGridExportCSV } from "@/components/pages/common/ag-grid/components/AGGridExportCSV";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { budgetDetailsBudgetNameSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsBudgetNameSelector";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";
import { AgGridAllFiltersChip } from "@/components/pages/common/ag-grid/components/filters/AgGridAllFiltersChip";

export const BudgetDetailsHistoryTable: FC = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const loading = useAppSelector(budgetDetailsByIdLoadingSelector);

  const budgetName = useAppSelector(budgetDetailsBudgetNameSelector);
  const period = useAppSelector(budgetDetailsPeriodSelector);
  const fileName = `${budgetName}-${period}-budget-history`;

  const processedData = useAppSelector(
    budgetDetailsHistoryProcessedDataSelector,
  );

  const height =
    rowHeight * (processedData?.length ?? 0) + headerRowHeight + paddings;

  return (
    <Fragment>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        height={32}
      >
        <Box>
          <AgGridAllFiltersChip gridApi={gridApi} />
        </Box>

        <AGGridExportCSV fullButton fileName={fileName} gridApi={gridApi} />
      </Stack>

      <Stack minHeight={250} height={height} maxHeight={400}>
        <AgDataGrid
          loading={loading}
          rowHeight={rowHeight}
          gridApiSetter={setGridApi}
          headerHeight={headerRowHeight}
          rowData={processedData ?? []}
          defaultColDef={defaultColDef}
          wrapperStyles={wrapperStyles}
          columnDefs={budgetDetailsHistoryTableColumnDefs}
        />
      </Stack>
    </Fragment>
  );
};

const rowHeight = 46;
const headerRowHeight = 50;
const paddings = 3;

const defaultColDef: ColDef = {
  flex: 1,
  minWidth: 150,
  maxWidth: 450,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
};

const wrapperStyles = {
  border: 1,
  borderRadius: 2,
  borderColor: "grey.300",
  "& .ag-root-wrapper": { borderRadius: 2 },
};
